import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons'
import styles from './Toast.module.scss'

const VARIANT_ICON = {
  success: 'check-circle',
  error: 'alert-circle',
  info: 'info',
  warning: 'alert-triangle',
}

const Toast = ({ id, message, variant = 'info', duration = 4000, onClose }) => {
  const { t } = useTranslation('common')
  const timerRef = useRef(null)

  useEffect(() => {
    if (duration <= 0) return undefined
    timerRef.current = setTimeout(() => onClose?.(id), duration)
    return () => clearTimeout(timerRef.current)
  }, [id, duration, onClose])

  const icon = VARIANT_ICON[variant] || VARIANT_ICON.info

  return (
    <div
      className={`${styles.toast} ${styles[`v_${variant}`] || ''}`}
      role={variant === 'error' || variant === 'warning' ? 'alert' : 'status'}
      aria-live={variant === 'error' || variant === 'warning' ? 'assertive' : 'polite'}
    >
      <span className={styles.icon} aria-hidden="true">
        <Icon name={icon} size={18} color="currentColor" />
      </span>
      <span className={styles.message}>{message}</span>
      <button
        type="button"
        className={styles.closeBtn}
        onClick={() => onClose?.(id)}
        aria-label={t('auto.toast.close', 'Закрыть уведомление')}
      >
        <Icon name="x" size={14} color="currentColor" />
      </button>
    </div>
  )
}

export default Toast
